import { PaymentMethodEnum as a } from "./payment-method.enum.mjs";
const r = (p, e) => {
  switch (p) {
    case a.stripe_card:
      return e("public_pages_purchase.payment.stripe_card");
    case a.stripe_ideal:
      return e("public_pages_purchase.payment.stripe_ideal");
    case a.stripe_bancontact:
      return e("public_pages_purchase.payment.stripe_bancotact");
    case a.stripe_applepay:
      return e("public_pages_purchase.payment.stripe_applepay");
    case a.stripe_klarna:
      return e("public_pages_purchase.payment.stripe_klarna");
    case a.stripe_multibanco:
      return e("public_pages_purchase.payment.stripe_multibanco");
    case a.dlocal_card:
      return e("public_pages_purchase.payment.dlocal_card");
    case a.dlocal_boleto:
      return e("public_pages_purchase.payment.dlocal_boleto");
    case a.dlocal_pix:
      return e("public_pages_purchase.payment.dlocal_pix");
    case a.paypal_soap:
    case a.paypal_rest:
      return e("public_pages_purchase.payment.paypal_soap");
    case a.mercadopago_br_card:
      return e("public_pages_purchase.payment.mercadopago_card");
    case a.mercadopago_br_pix:
      return e("public_pages_purchase.payment.mercadopago_pix");
    case a.mercadopago_br_boleto:
      return e("public_pages_purchase.payment.mercadopago_boleto");
    case a.mercadopago_co_card:
    case a.mercadopago_ar_card:
    case a.mercadopago_mx_card:
    case a.mercadopago_cl_card:
      return e("public_pages_purchase.payment.mercadopago_card");
    case a.razorpay:
      return e("public_pages_purchase.payment.razorpay");
    case a.flutterwave:
      return e("public_pages_purchase.payment.flutterwave");
    case a.mollie:
      return e("public_pages_purchase.payment.mollie");
    case a.gocardless:
      return e("public_pages_purchase.payment.gocardless");
    case a.cash_on_delivery:
      return e("public_pages_purchase.payment.cash_on_delivery");
    case a.xendit_id_card:
    case a.xendit_ph_card:
      return e("public_pages_purchase.payment.xendit_card");
    case a.paystack_gh_card:
    case a.paystack_ke_card:
    case a.paystack_ng_card:
    case a.paystack_za_card:
    case a.paystack_eg_card:
    case a.paystack_ci_card:
      return e("public_pages_purchase.payment.paystack_card");
    case a.secure_and_pay:
      return e("public_pages_purchase.payment.secure_and_pay");
  }
};
export {
  r as getPaymentMethodTitle
};
